/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 * @description Full Zumper Logo - Stacked (Vertical)
 */

import type { ImgIconProps } from '@zcode-ui/icons'
import React from 'react'
import logo from './zumperStacked.svg'

export const ZumperStackedHalloween = ({ alt = 'Zumper', size = 64, ...props }: ImgIconProps) => {
  return (
    <img alt={alt} height={size} loading="lazy" src={logo} width={(145 / 116) * size} {...props} />
  )
}
